import { render, staticRenderFns } from "./Mobileheader.vue?vue&type=template&id=6afcfee5&scoped=true"
import script from "./Mobileheader.vue?vue&type=script&lang=js"
export * from "./Mobileheader.vue?vue&type=script&lang=js"
import style0 from "./Mobileheader.vue?vue&type=style&index=0&id=6afcfee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afcfee5",
  null
  
)

export default component.exports